import React, { useEffect } from "react";
import { Button, Input } from "reactstrap";
import "./EmailSubject.scss";

const EmailSubject = ({
  formik,
  name,
  icon,
  placeholder = "",
  allModuleData,
  jobStage,
}) => {
  useEffect(() => {
    if (allModuleData && jobStage) {
      const firstName = allModuleData?.Candidates?.basicInfo?.firstName || "";
      const lastName = allModuleData?.Candidates?.basicInfo?.lastName || "";
      const accountName = allModuleData?.Jobs?.jobInfo?.accountName || "";
      const jobTitle = allModuleData?.Jobs?.jobInfo?.jobTitle || "";
      const subject = `${jobStage}: ${accountName} | ${jobTitle} | ${firstName} ${lastName}`;
      formik.setFieldValue(name, subject);
    }
  }, [allModuleData, jobStage]);

  return (
    <div className="d-flex align-items-center gap-2 ">
      <div
        style={{
          width: "40px",
        }}
      >
        <Button
          className="px-1 py-0"
          style={{
            height: "28px",
            width: "28px",
            backgroundColor: "#F5F5F5",
            border: "1px solid #A8A8A8",
            color: "#7A7A7A",
          }}
        >
          {icon && icon}
        </Button>
      </div>
      <span className="text-muted">Subject</span>
      <div className="d-flex flex-row align-items-center justify-content-start gap-3 w-100">
        <div className="subject-container">
          <Input
            type="text"
            className="subject-input"
            name="subject"
            value={formik?.values?.[name]}
            onChange={(event) => {
              formik.setFieldValue(name, event.target.value);
            }}
            onBlur={formik.handleBlur}
            placeholder={placeholder}
          />
        </div>
      </div>
    </div>
  );
};

export default EmailSubject;
